import { createFileRoute } from '@tanstack/react-router'

import { BrokerOverviewPage } from '#/modules/fmcsa/overview-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/broker-overview')({
  component: BrokerOverviewPage,
  validateSearch: validateListSearch,
})
